module.exports = __webpack_public_path__ + "2cb3b5627231305e20ef945bcf0e7ea5.mp3";